import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

const HIGHLIGHTS = [
  "Full-service marketing & BPO under one roof",
  "Trained English-speaking agents & senior specialists",
  "Serving clients across the US, Canada, UK, Middle East & APAC",
  "Headquartered in Mirpur DOHS, Dhaka, Bangladesh",
];

export const About = () => {
  return (
    <section id="about" className="relative py-[var(--section-py)]" data-testid="about-section">
      <div className="mx-auto max-w-[var(--container-max)] px-4 sm:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-5"
          >
            <div className="relative overflow-hidden rounded-[var(--radius)] border border-white/10 shadow-[var(--shadow-elev-2)]">
              <img
                src="https://images.pexels.com/photos/8204312/pexels-photo-8204312.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="GrowthSync Solutions team at work with headsets"
                loading="lazy"
                className="aspect-[4/3] w-full object-cover"
              />
              <div className="absolute inset-0 bg-[rgba(10,14,26,0.35)]" />
              <div className="absolute bottom-4 left-4 rounded-lg border border-[color:var(--gs-line)] bg-[rgba(10,14,26,0.85)] px-4 py-2 backdrop-blur">
                <p className="font-display text-sm font-semibold text-[color:var(--gs-gold-400)]">
                  Dhaka, Bangladesh
                </p>
                <p className="text-xs text-white/60">Global delivery hub</p>
              </div>
            </div>
          </motion.div>

          {/* Copy */}
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="lg:col-span-7"
          >
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[color:var(--gs-gold-400)]">
              About Us
            </p>
            <h2 className="font-display mt-3 text-3xl font-bold text-white sm:text-4xl" data-testid="about-heading">
              One team. Every system your{" "}
              <span className="text-[color:var(--gs-gold-400)]">growth</span> needs.
            </h2>
            <div className="mt-4 h-1 w-16 rounded bg-[color:var(--gs-gold-400)]" />
            <p className="mt-6 leading-relaxed text-white/70">
              GrowthSync Solutions is a full-service marketing and BPO company headquartered
              in Dhaka, Bangladesh. We help businesses around the world strategize, connect,
              and grow — combining the human touch of trained telemarketing and support teams
              with the precision of AI-driven marketing and modern software engineering.
            </p>
            <p className="mt-4 leading-relaxed text-white/70">
              Whether you need a pipeline full of qualified leads, a website that converts,
              a 24/7 support desk, or a beautifully designed space — we deliver it with one
              accountable team, transparent reporting, and enterprise-grade execution.
            </p>
            <ul className="mt-7 space-y-3">
              {HIGHLIGHTS.map((point) => (
                <li key={point} className="flex items-start gap-3 text-sm text-white/80">
                  <CheckCircle2 className="mt-0.5 h-4.5 w-4.5 shrink-0 text-[color:var(--gs-gold-400)]" size={18} />
                  {point}
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
